import React, { FC } from "react";

import { Skeleton } from "../../skeleton/skeleton";
import { JobDetailLayout } from "./job-detail-layout";

export interface JobDetailSkeletonProps {
  labels: Record<string, string | null>;
}

export const JobDetailSkeleton: FC<JobDetailSkeletonProps> = ({ labels }) => {
  return (
    <JobDetailLayout
      labels={labels}
      title={<Skeleton width="66%" />}
      description={<Skeleton height={112} />}
      jobDescription={<Skeleton height={80} />}
      ctas={null}
    />
  );
};
